import axios from 'axios';
import logger from '../utils/logger';

// Use environment variable for API URL, fallback to production if not set
const API_URL = import.meta.env.REACT_APP_API_URL || 'https://api.spark.rapidlearningcycles.com';

// Auth header from the stored user token (mirrors aiCoachService)
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {};
};

// Question Evaluator service (REQ-001 — stateless, AI-only)
const questionEvaluatorService = {
  /**
   * Evaluate a Key Decision or Knowledge Gap question against the RLC "will" test.
   * @param {string} question - The user's question (1–2000 chars).
   * @param {('key_decision'|'knowledge_gap')} type - The question type to evaluate against.
   * @returns {Promise<Object>} QuestionEvalResult
   *   { fits, verdict, criteria, reshape, switch_suggestion, model_used }
   */
  evaluate: async (question, type) => {
    try {
      const response = await axios.post(
        `${API_URL}/productivity/question/evaluate`,
        { question, type },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error evaluating question:', error);
      throw error;
    }
  }
};

export default questionEvaluatorService;
